import { Injectable, OnInit } from '@angular/core';
import { DrupalRESTService } from './drupal-rest.service';
import { TaxonomyOverridesService } from './taxonomy-overrides.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class TaxonomyService implements OnInit {

  enrollment_type = [];
  group_lesson_types = [];
  lesson_status = [];
  lesson_type = [];
  package_code = [];
  payment_type = [];
  // Every published payment type, ignoring the studio's visibility overrides.
  // Lookups by id (existing payments, report filters, imports) must use this
  // list; `payment_type` only drives what a studio can pick for NEW payments.
  payment_type_all = [];
  schedule_type = [];
  service_status = [];
  service_type = [];
  sps_code = [];
  student_department = [];
  teacher_category = [];

  constructor(
    private drupalRESTService: DrupalRESTService,
    private taxonomyOverridesService: TaxonomyOverridesService,
  ) {
    // Re-filter whenever the studio's overrides load or the studio changes.
    this.taxonomyOverridesService.getOverrides().subscribe(() => {
      this.applyStudioPaymentTypeVisibility();
    });
  }

  ngOnInit(): void {
  }

  initTaxonomyTerms() {
    return new Promise((resolve, reject) => {
      this.drupalRESTService.httpGET("/api_rest/v1/taxonomy")
        .subscribe(data => {
          // Clear existing taxonomy terms
          this.clearTaxonomyTerms();

          // Respect "published" and "hide"
          for (const taxonomy_term in data) {
            data[taxonomy_term].forEach((element: any) => {
              if (element.hide == false && element.published) {
                this[taxonomy_term].push(element);
              } else {
                // LoggerService.log(element);
              }
            });
          }

          // Sort lesson types: push "Hold" to the bottom
          if (this.lesson_type.length > 0) {
            this.lesson_type.sort((a, b) => {
              const aIsHold = a.name === 'Hold';
              const bIsHold = b.name === 'Hold';
              if (aIsHold && !bIsHold) return 1;
              if (!aIsHold && bIsHold) return -1;
              return a.name.localeCompare(b.name);
            });
          }

          // Sort lesson statuses in specific order
          if (this.lesson_status.length > 0) {
            const statusOrder = ['59', '64', '62', '63', '1425', '60', '61']; // TIDs in desired order
            this.lesson_status.sort((a, b) => {
              const aIndex = statusOrder.indexOf(a.id);
              const bIndex = statusOrder.indexOf(b.id);
              // If both are in our ordered list, sort by that order
              if (aIndex !== -1 && bIndex !== -1) {
                return aIndex - bIndex;
              }
              // If only one is in our ordered list, prioritize it
              if (aIndex !== -1) return -1;
              if (bIndex !== -1) return 1;
              // If neither is in our ordered list, sort alphabetically
              return a.name.localeCompare(b.name);
            });
          }

          // Alphabetize payment types. The API returns them in raw weight order.
          this.payment_type_all = [...this.payment_type].sort(
            (a, b) => a.name.localeCompare(b.name)
          );
          this.applyStudioPaymentTypeVisibility();

          resolve(true);
        });
    })
  }

  /** Drops payment types the current studio has hidden via taxonomy overrides
   *  and orders the rest by the studio's saved weight (alphabetical fallback;
   *  payment_type_all is already alphabetized). A studio's override row always
   *  wins; with no row, opt-in types (hidden_by_default from the API) stay out. */
  private applyStudioPaymentTypeVisibility() {
    const overrides = this.taxonomyOverridesService.getOverridesSnapshot();
    this.payment_type = this.payment_type_all
      .filter(term => {
        const override = overrides[String(term.id)];
        return override ? !override.hide : !term.hidden_by_default;
      })
      .sort((a, b) => {
        const weightA = overrides[String(a.id)]?.weight;
        const weightB = overrides[String(b.id)]?.weight;
        if (weightA != null && weightB != null) { return weightA - weightB; }
        if (weightA != null) { return -1; }
        if (weightB != null) { return 1; }
        return a.name.localeCompare(b.name);
      });
  }

  private clearTaxonomyTerms() {
    this.enrollment_type = [];
    this.group_lesson_types = [];
    this.lesson_status = [];
    this.lesson_type = [];
    this.package_code = [];
    this.payment_type = [];
    this.payment_type_all = [];
    this.schedule_type = [];
    this.service_status = [];
    this.service_type = [];
    this.sps_code = [];
    this.student_department = [];
    this.teacher_category = [];
  }
}

